<!-- Email Composition Modal -->
<div class="modal fade" id="emailCompositionModal" tabindex="-1" role="dialog" aria-labelledby="emailCompositionModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="emailCompositionModalLabel">Compose Email</h5>
        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <form [formGroup]="emailForm">
          <!-- Recipients Section -->
          <div class="card mb-3">
            <div class="card-header bg-light">
              <h6 class="mb-0">Recipients</h6>
            </div>
            <div class="card-body">
              <!-- To Field -->
              <div class="form-group mb-3">
                <label for="mailTo" class="form-label">
                  To
                  <span class="text-danger">*</span>
                </label>
                <input type="email" 
                       class="form-control" 
                       id="mailTo"
                       formControlName="mailTo"
                       placeholder="email@example.com (comma-separated for multiple)"
                       [class.is-invalid]="isFieldInvalid('mailTo')">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('mailTo')">
                  Email address is required and must be valid.
                </div>
                <small class="text-muted">Separate multiple emails with commas</small>
              </div>

              <!-- CC Field -->
              <div class="form-group mb-3">
                <label for="mailCC" class="form-label">CC</label>
                <input type="text" 
                       class="form-control" 
                       id="mailCC"
                       formControlName="mailCC"
                       placeholder="email@example.com (optional)">
                <small class="text-muted">Separate multiple emails with commas</small>
              </div>

              <!-- BCC Field -->
              <div class="form-group mb-3">
                <label for="mailBCC" class="form-label">BCC</label>
                <input type="text" 
                       class="form-control" 
                       id="mailBCC"
                       formControlName="mailBCC"
                       placeholder="email@example.com (optional)">
                <small class="text-muted">Separate multiple emails with commas</small>
              </div>

              <!-- Quick Add Users (Optional) -->
              <div class="form-group mb-0">
                <label class="form-label">Quick Add Users</label>
                <div class="input-group mb-2">
                  <ng-select [items]="availableUsers"
                             bindLabel="fullName"
                             bindValue="email"
                             placeholder="Select users to add..."
                             [clearable]="true"
                             [searchable]="true"
                             multiple="false"
                             (change)="onUserSelected($event)">
                    <ng-template ng-label-tmp let-value="value" let-item="item">
                      <div *ngIf="item" class="d-flex">
                        <span>{{ item.fullName }}</span>
                        <small class="text-muted ms-2" *ngIf="item.roles && item.roles.length > 0">
                          ({{ item.roles.join(', ') }})
                        </small>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                      <div class="d-flex justify-content-between w-100">
                        <span>{{ item.fullName }}</span>
                        <small class="text-muted" *ngIf="item.roles && item.roles.length > 0">
                          {{ item.roles.join(', ') }}
                        </small>
                      </div>
                    </ng-template>
                  </ng-select>
                  <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="button" (click)="addToRecipients()">
                      Add to To
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Subject Section -->
          <div class="form-group mb-3">
            <label for="mailSubject" class="form-label">
              Subject
              <span class="text-danger">*</span>
            </label>
            <input type="text" 
                   class="form-control" 
                   id="mailSubject"
                   formControlName="mailSubject"
                   placeholder="Enter email subject"
                   [class.is-invalid]="isFieldInvalid('mailSubject')">
            <div class="invalid-feedback" *ngIf="isFieldInvalid('mailSubject')">
              Subject is required.
            </div>
          </div>

          <!-- Body Section -->
          <div class="form-group mb-3">
            <label for="mailBody" class="form-label">
              Body
              <span class="text-danger">*</span>
            </label>
            
            <!-- Rich Text Editor Toolbar -->
            <div class="btn-toolbar mb-2" role="toolbar">
              <div class="btn-group btn-group-sm me-2" role="group">
                <button type="button" class="btn btn-outline-secondary" title="Bold" (click)="insertTag('b')">
                  <strong>B</strong>
                </button>
                <button type="button" class="btn btn-outline-secondary" title="Italic" (click)="insertTag('i')">
                  <em>I</em>
                </button>
                <button type="button" class="btn btn-outline-secondary" title="Underline" (click)="insertTag('u')">
                  <u>U</u>
                </button>
              </div>
              <div class="btn-group btn-group-sm me-2" role="group">
                <button type="button" class="btn btn-outline-secondary" title="Heading 1" (click)="insertTag('h1')">
                  H1
                </button>
                <button type="button" class="btn btn-outline-secondary" title="Heading 2" (click)="insertTag('h2')">
                  H2
                </button>
              </div>
              <div class="btn-group btn-group-sm me-2" role="group">
                <button type="button" class="btn btn-outline-secondary" title="Paragraph" (click)="insertTag('p')">
                  &para;
                </button>
                <button type="button" class="btn btn-outline-secondary" title="Line Break" (click)="insertLineBreak()">
                  &crarr;
                </button>
              </div>
              <div class="btn-group btn-group-sm" role="group">
                <button type="button" class="btn btn-outline-secondary" title="Unordered List" (click)="insertTag('ul')">
                  <i class="fas fa-list-ul"></i>
                </button>
                <button type="button" class="btn btn-outline-secondary" title="Ordered List" (click)="insertTag('ol')">
                  <i class="fas fa-list-ol"></i>
                </button>
              </div>
            </div>

            <!-- Text Area -->
            <textarea class="form-control" 
                      id="mailBody"
                      formControlName="mailBody"
                      rows="12"
                      placeholder="Enter email body (HTML tags supported)"
                      [class.is-invalid]="isFieldInvalid('mailBody')"
                      #bodyTextArea>
            </textarea>
            <div class="invalid-feedback" *ngIf="isFieldInvalid('mailBody')">
              Email body is required.
            </div>

            <!-- Preview Area -->
            <div class="mt-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="showPreview" [(ngModel)]="showPreview" [ngModelOptions]="{standalone: true}">
                <label class="form-check-label" for="showPreview">
                  Show Preview
                </label>
              </div>
              
              <div *ngIf="showPreview" class="alert alert-light border mt-2 p-3" style="max-height: 300px; overflow-y: auto;">
                <strong>Preview:</strong>
                <div [innerHTML]="emailForm.get('mailBody')?.value"></div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" 
                class="btn btn-primary" 
                (click)="sendEmail()"
                [disabled]="!emailForm.valid || isSending">
          <span *ngIf="isSending" class="spinner-border spinner-border-sm me-2"></span>
          {{ isSending ? 'Sending...' : 'Send Email' }}
        </button>
      </div>
    </div>
  </div>
</div>

